import CompactInventoryCard from "@Components/CompactInventoryCard";
import { useEffect, useState } from "react";
import classes from "./PopularPropertiesSection.module.scss";
import SectionContainer from "@Pages/PropertyPage/components/SectionContainer";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import HorizontalScroll from "@Components/HorizontalScroll";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
import { APP_PAGE } from "@Utils/webApputils/analyticEvents";
import { getInventoryPopularPropertiesById } from "./helper";
import filterOutWhitelabelInventories from "@Pages/PropertyPage/data/helper";
import useWhitelabel from "hooks/useWhitelabel";

interface PopularPropertiesProps {
  gtagEventCategory: string;
  isDesktop: boolean;
}

const PopularProperties = ({ gtagEventCategory, isDesktop }: PopularPropertiesProps) => {
  const { inventory, userCurrency } = useSelector(
    ({ propertyPageData, appData }: AppState) => ({
      id: propertyPageData?.data?.id,
      inventory: propertyPageData.data,
      userCurrency: appData.userCurrency,
    }),
    shallowEqual,
  );

  const { t } = useTranslationHook();
  const { isWhitelabel } = useWhitelabel();
  const [listings, setListings] = useState<any>([]);

  const getListings = async () => {
    const popularPropertiesData = await getInventoryPopularPropertiesById({
      inventory_id: inventory?.id,
      userCurrency,
    });
    if (popularPropertiesData && popularPropertiesData?.length > 0) {
      const filteredListings = isWhitelabel
        ? popularPropertiesData
        : filterOutWhitelabelInventories(popularPropertiesData);

      setListings(filteredListings);

      if (filteredListings?.length === 0) {
        const event = new Event("navigation_section_removed");
        window.dispatchEvent(event);
      }
      const enrichedProperties = popularPropertiesData.map((inv: any) => ({
        ...inv,
        images: [...(inv?.images_with_featured || []), ...(inv?.images || [])],
      }));
      setListings(enrichedProperties);
    } else {
      const event = new Event("navigation_section_removed");
      window.dispatchEvent(event);
      setListings([]);
    }
  };

  useEffect(() => {
    getListings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inventory?.id]);

  const PopularPropertiesHeadline = t("Popular Properties");

  return (
    <>
      {listings?.length > 0 && (
        <SectionContainer
          title={PopularPropertiesHeadline}
          id="popular_properties"
          className={formatClassNames(
            classes.container,
            isDesktop ? classes.desktop : "",
            isDesktop ? classes.bottomMargin : "",
          )}
          isDesktop={isDesktop}
          showTitleLine
          headingLevel={2}
        >
          <HorizontalScroll
            className={formatClassNames(
              classes.scrollContainer,
              isDesktop ? classes.scrollContainerDesktop : "",
            )}
            showControls={isDesktop}
          >
            {listings.map((item: any) => (
              <CompactInventoryCard
                item={item}
                key={item.id}
                isRequestActive={false}
                isDesktop={isDesktop}
                showIcons
                gtagEventAction="clicked_popular_properties"
                gtagEventCategory={gtagEventCategory}
                screenName={APP_PAGE.PROPERTY}
              />
            ))}
          </HorizontalScroll>
        </SectionContainer>
      )}
    </>
  );
};

export default wrapperHOC(PopularProperties, {
  componentName: "PopularProperties-SearchPage",
  showForChina: true,
  showForWhiteLable: true,
});
